import { OrderPaymentStatusEnum, StatusToneEnum } from '@ztechapps/common.contract'

// Each custom color is a CSS custom property declared in libs/webui/util/src/Status/StatusColor.scss; it resolves only in a browser that has loaded that stylesheet.
export const OrderPaymentStatus = {
  unpaid: {
    value: OrderPaymentStatusEnum.unpaid,
    description: 'The item is still in cart',
    color: 'var(--status-custom-maroon)',
  },
  partiallyPaid: {
    value: OrderPaymentStatusEnum.partiallyPaid,
    description: 'The quotation for the order is added',
    color: 'var(--status-custom-orange)',
  },
  paid: {
    value: OrderPaymentStatusEnum.paid,
    description: 'The order is still being process/prepared',
    tone: StatusToneEnum.Active,
  },
  overPaid: {
    value: OrderPaymentStatusEnum.overPaid,
    description: 'The order preparation was done, and ready for payment from the buyer.',
    color: 'var(--status-custom-magenta)',
  },
  notReceivable: {
    value: OrderPaymentStatusEnum.notReceivable,
    description: 'The order has been marked uncollectible and is excluded from accounts receivable.',
    tone: StatusToneEnum.Inactive,
  },
}
